export default "Alt du ved er, at du intet ved ...";